import { render, staticRenderFns } from "./CreatorProfileShihoMasuda.vue?vue&type=template&id=618a9968&scoped=true&"
import script from "./CreatorProfileShihoMasuda.vue?vue&type=script&lang=js&"
export * from "./CreatorProfileShihoMasuda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618a9968",
  null
  
)

export default component.exports